import { render, staticRenderFns } from "./CustomerSendModal.vue?vue&type=template&id=05182026&"
import script from "./CustomerSendModal.vue?vue&type=script&lang=js&"
export * from "./CustomerSendModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports